import { render, staticRenderFns } from "./ContentOfferRecord.vue?vue&type=template&id=24c28fde&scoped=true&"
import script from "./ContentOfferRecord.vue?vue&type=script&lang=js&"
export * from "./ContentOfferRecord.vue?vue&type=script&lang=js&"
import style0 from "./ContentOfferRecord.vue?vue&type=style&index=0&id=24c28fde&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c28fde",
  null
  
)

export default component.exports